var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "card-head normal-page",
          attrs: {
            shadow: "never",
            "body-style": { padding: "20px 20px 0 20px" },
          },
        },
        [
          _c("oaFromBox", {
            attrs: {
              search: _vm.searchData,
              title: _vm.$route.meta.title,
              total: _vm.total,
              isViewSearch: false,
              sortSearch: false,
              isAddBtn: false,
            },
            on: { confirmData: _vm.confirmData },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box mt20" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.tableData },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "id", label: "ID", "min-width": "80" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "user_name",
                      label: _vm.$t("toptable.operationuser"),
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "event_name",
                      label: _vm.$t("toptable.behavior"),
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "path",
                      label: _vm.$t("toptable.link"),
                      "min-width": "195",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "terminal",
                      label: _vm.$t("toptable.loginterminal"),
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "last_ip",
                      label: _vm.$t("toptable.operationip"),
                      "min-width": "100",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: _vm.$t("toptable.operationtime"),
                      "min-width": "165",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-pagination", {
                attrs: {
                  "page-size": _vm.formData.limit,
                  "current-page": _vm.formData.page,
                  "page-sizes": [10, 15, 20],
                  layout: "total, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }